/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Subtitle_ExportInputs */



/**
* | output |
* | --- |
* | "Summary and comments" |
*
* @param {Intervention_Plan_Subtitle_ExportInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_subtitle_export = /** @type {((inputs?: Intervention_Plan_Subtitle_ExportInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Subtitle_ExportInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summary and comments")
	return /** @type {LocalizedString} */ ("Résumé et commentaires")
});